import React from 'react';
import Styled from 'styled-components';
import MoodTrackerModalHook from '@organisms/modals/MoodTrackerModalHook';

const Wrapper = Styled.div`
  min-height: 60vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  background-color: #E3F4FE;
`;

const QuizIcon = Styled.img`
  height: 62px;
  width: 56px;
  margin-right: -15px;
  margin-bottom: 30px;
`;

const Title = Styled.p`
  font-size: 20px;
  font-weight: 300;
  line-height: 17px;
  margin: 0 0 20px 0;
`;

const DescriptionText = Styled.p`
  max-width: 650px;
  font-size: 14px;
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
`;

const Openbutton = Styled.button`
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 3px;
  padding: 12px 20px;
  margin-top: 10px;
  background-color: ${({ theme }) => theme.colors.primary['blue-2']};
  cursor: pointer;
`;

const MoodTrackerOverlay = ({
  moodTracker,
  title,
  description,
  start_button_text,
  onComplete,
  modalTitle,
  modalDesc,
}) => {
  const [MoodTrackerModal, { openModal, closeModal }] = MoodTrackerModalHook({
    title: modalTitle,
    desc: modalDesc,
    moodTracker: moodTracker,
    open: false,
    onComplete() {
      // called after mutation respond
      // we should send a notification up to refresh the program query
      // then close
      closeModal();
      onComplete();
    },
  });

  return moodTracker?.id ? (
    <>
      <Wrapper
        data-testtype="MoodTrackerOverlay"
        data-testid={`MoodTrackerOverlay--${moodTracker.kind}`}
      >
        <QuizIcon src="/static/icons/quiz-illustration.svg" alt="quiz icon" />
        <Title data-testid="MoodTrackerOverlay--Title">{title}</Title>
        <DescriptionText data-testid="MoodTrackerOverlay--Description">
          {description}
        </DescriptionText>
        <Openbutton
          data-testid="MoodTrackerOverlay--Button"
          onClick={openModal}
        >
          {start_button_text}
        </Openbutton>
      </Wrapper>
      {MoodTrackerModal}
    </>
  ) : null;
};

export default MoodTrackerOverlay;
